import LiveBusMap from './LiveBusMap'
import {fetchDailyTrips} from './api'
import {useQueries} from 'react-query'
import {PageTitle} from '../../../_metronic/layout/core'
import {fetchSchoolDetails} from '../profile/api'
import {Helmet} from 'react-helmet'
import {Processing} from '../../../components/Loaders'
import {toGeoJSON} from '../../../helpers/toGeoJSON'
// import useMockBusLocations from './useMockBusLocations'

const allBusLocationBreadCrumbs = [
  {
    title: 'All Bus Location',
    path: '/trip/live-trip',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const LiveTrip = () => {
  const date = new Date()
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  const formattedDate = `${year}-${month}-${day}`

  const results = useQueries([
    {
      queryKey: 'busLocations',
      queryFn: () => fetchDailyTrips(formattedDate),
      refetchOnWindowFocus: false,
      select: (data) => {
        if (!data.data) {
          return {geoJson: {type: 'FeatureCollection', features: []}} // Return empty GeoJSON if data is missing
        }

        let busData = {
          geoJson: toGeoJSON(data.data, (loc) => ({
            daily_trip_id: loc.daily_trip_id,
            bus_id: loc.bus_id,
            bus_name: loc.bus_name,
            bus_number: loc.bus_number,
            driver_name: loc.driver_name,
            bus_registration_number: loc.bus_registration_number,
          })),
          ...data.data,
        }

        return busData
      },
      refetchInterval: 2000,
    },
    {
      queryKey: 'school_details',
      queryFn: fetchSchoolDetails,
      refetchOnWindowFocus: false,
    },
  ])

  // const busGeoJson = useMockBusLocations()

  if (results[0].isLoading || results[1].isLoading) {
    return <Processing />
  }

  const busGeoJson = results[0]?.data.geoJson
  const schoolDetails = results[1]?.data?.data

  return (
    <div>
      <Helmet>
        <title>TrackNAB | Live Trip</title>
      </Helmet>
      <PageTitle breadcrumbs={allBusLocationBreadCrumbs}>Live Trip</PageTitle>

      {busGeoJson && schoolDetails && (
        <LiveBusMap
          busGeoJson={busGeoJson}
          schoolLocation={{
            lat: schoolDetails?.school_location_latitude,
            lng: schoolDetails?.school_location_longitude,
          }}
        />
      )}
    </div>
  )
}

export default LiveTrip
